/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import "react-reflex/styles.css";

import layoutConf from "../../config/layoutConf";

import notificationState from "../../states/notificationState";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";

import MomSysBop from "./MomSysBop";
import MomSysBom from "./MomSysBom";
import MomSysBopWarehouse from "./MomSysBopWarehouse";

import MomSysBomBopTreeButton from "../input/MomSysBomBopTreeButton";
import CopyBomBopButton from "../input/CopyBomBopButton";

function MomSysBomBopInfo(props) {

    const { t } = useTranslation();

    const [grid, setGrid] = useState();
    const [materialApi, setMaterialApi] = useState();
    const [wareHouse, setWareHouse] = useState();
    const [product, setProduct] = useState();
    const [process, setProcess] = useState();
    const [height, setHeight] = useState(0);

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    useEffect(() => {

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);

    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler((grid, event) => {

                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        let product = grid.selectedItems[0];

                        setProduct ( product );

                    }

                });

                grid.itemsSourceChanged.addHandler((grid, event) => {

                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        let product = grid.selectedItems[0];

                        setProduct ( product );

                    }

                });

            }
        })();

    }, [grid]);

    const onGridInitialized = (grid) => {

        grid.selectionMode = "Row";
        
        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setMaterialApi ( api );

    };

    const onWareHouseInitialized = (wareHouse) => {

        setWareHouse ( wareHouse );

    }

    const onSelectProcess = ( process ) => {

        setProcess ( process );

    }

    const onChangeProcess = () => {

        if ( wareHouse ) {

            setProduct ( ( product ) => {

                wareHouse.refresh ( product );
                return product;

            } );

        }

    }

    return (

        <div style={{ height: height }}>

            <ReflexContainer orientation="vertical">

                <ReflexElement flex={0.4}>

                    <ReflexContainer orientation="horizontal">

                        <ReflexElement flex={0.6}>

                            <BasicCrudScreenType
                                id="MomSysZvwProduceableMaterial"
                                headerTitle={t("term.outputMaterial")}
                                table="MomSysZvwProduceableMaterial"
                                view="MomSysZvwProduceableMaterial"
                                onAppendButtonAtFirst={() =>
                                    <>

                                        <BasicCrudScreenActionItemLayout>

                                            <MomSysBomBopTreeButton color="primary" product={product} />

                                        </BasicCrudScreenActionItemLayout>

                                    </>

                                }
                                onAppendButtonInFrontOfSearch={() =>

                                    <>
                                        <BasicCrudScreenActionItemLayout>

                                            <AccessControl accessTarget="MomSysUdtBillOfProcess" accessMethod="POST">
                                                <CopyBomBopButton
                                                    id={"copy-bom-bop-button"}
                                                    refresh={materialApi}
                                                    onSuccess={( msg ) => notifySuccess ( msg )}
                                                    createButtonName="copyBomBop"
                                                />
                                            </AccessControl>

                                        </BasicCrudScreenActionItemLayout>
                                    </>

                                }
                                noCreate
                                noEdit
                                noDelete
                                noExcel
                                onInitialized={onGridInitialized}
                                onApiInitialized={onApiInitialized}
                            />

                        </ReflexElement>

                        <ReflexSplitter
                            style={{ height: layoutConf.reflex.splitterHeight }}
                        />

                        <ReflexElement flex={0.4}>

                            <MomSysBopWarehouse product={product} onInitialized={onWareHouseInitialized} />

                        </ReflexElement>

                    </ReflexContainer>

                </ReflexElement>

                <ReflexSplitter
                    style={{ width: layoutConf.reflex.splitterWidth }}
                />

                <ReflexElement>

                    <ReflexContainer orientation="horizontal">

                        <ReflexElement flex={0.5}>

                            <MomSysBop product={product} onSelect={onSelectProcess} onChange={onChangeProcess} />

                        </ReflexElement>

                        <ReflexSplitter
                            style={{ height: layoutConf.reflex.splitterHeight }}
                        />

                        <ReflexElement flex={0.5}>

                            <MomSysBom process={process} />

                        </ReflexElement>

                    </ReflexContainer>

                </ReflexElement>

            </ReflexContainer>

        </div>

    );

}

export default MomSysBomBopInfo;
